import {
  HeaderTypes,
  HttpClientHelper,
  PTVNClient,
} from "@ptvn-react/authentication";
import { AxiosRequestConfig } from "axios";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import APIConstant from "../utils/constants/APIConstant";
import { PTVNResponse } from "./response/BaseResponse";
import { GetUaaAuthCodeResponse } from './response/IntegrateResponse';

export class IntegrationClient {

  public static getAuthCode(tenantID: string): Observable<PTVNResponse<GetUaaAuthCodeResponse>> {
    const url = `${APIConstant.integration.getAuthCode}`.replace("{tenantID}", tenantID.toString());
    const options: AxiosRequestConfig = HttpClientHelper.getRequestOptions(
      HeaderTypes.SSO_TOKEN
    );
    return PTVNClient.get(url, options).pipe(map((m) => m.data));
  }

}
